import AppBarMobile from "components/AppBarMobile/AppBarMobile";
import AppBarTablet from "components/AppBarTablet/AppBarTablet";
import { useMemo } from "react";

function AppBar(props) {
  // Note: dispatch might be undefined
  const { currentPageKey, t, dispatch } = props;
  // Pages with more than one view under the same url have to be reset to the initial state after clicking the page on the app bar
  const onAppBarPageClick = useMemo(() => {
    switch (currentPageKey) {
      case "deliverNew":
        return dispatch ? () => dispatch.deliverNew.reset() : () => {};
      case "campaigns":
        return dispatch ? () => dispatch.campaignsPage.reset() : () => {};
      default:
        return () => {};
    }
  }, [currentPageKey]);
  return (
    <>
      <div className="mobile-only">
        <AppBarMobile currentPageKey={currentPageKey} onAppBarPageClick={onAppBarPageClick} t={t} />
      </div>
      <div className="larger-than-mobile">
        <AppBarTablet currentPageKey={currentPageKey} onAppBarPageClick={onAppBarPageClick} t={t} />
      </div>
    </>
  );
}

export default AppBar;
